if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          Alpine.store("xHeaderMenu")?.suppressScroll?.();
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async addToCart(e, required, quickView, sticky) {
          const addToBundle = quickView && Alpine.store('xQuickView') && Alpine.store('xQuickView').bundleTarget;
          if (!addToBundle) this.loading = true;
          e.preventDefault();

          setTimeout(async () => {
            if (required && !addToBundle) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.main-product .product-info') || document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      Alpine.store("xHeaderMenu")?.suppressScroll?.();
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              

                if (!this.stopAction) {
                  productInfo.querySelectorAll('.recipient_input').forEach(giftCardInput => {
                    if (!this.stopAction && giftCardInput.required) {
                      this.stopAction = Alpine.$data(giftCardInput.closest('[x-data]')).onChangeInput(giftCardInput);
                      if (this.stopAction) {
                        Alpine.store("xHeaderMenu")?.suppressScroll?.();
                        giftCardInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }
                    }
                  });
                }
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            if (addToBundle) {
              const bundleTarget = Alpine.store('xQuickView').bundleTarget;
              const selectedVariantEl = document.getElementById('quickview-product-content')?.querySelector('script[type="application/json"][data-selected-variant]');
              const quickViewFormData = new FormData(this.$refs.product_form);

              document.dispatchEvent(new CustomEvent(`eurus:quickview:add-to-bundle:${bundleTarget}`, {
                detail: {
                  variant: selectedVariantEl ? JSON.parse(selectedVariantEl.textContent) : null,
                  quantity: Number(quickViewFormData.get('quantity')) || 1
                }
              }));
              Alpine.store('xQuickView').close();
              return true;
            }

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');
            const linkedProductListQty = newFormData.getAll('properties[_linked_product_id_qty][]');
            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) || 
              (linkedProductList.length > 0) ||
              (linkedProductListQty.length > 0)
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductListQty.length > 0) {
                let qty = newFormData.get('quantity');
                linkedProductListQty.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: qty,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              
              if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) {
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                additionalOptionData.forEach((item, index) => {
                  const base = `items[${index}]`;

                  newFormData.append(`${base}[id]`, item.id);
                  newFormData.append(`${base}[quantity]`, item.quantity);

                  if (item.parent_id) {
                    newFormData.append(`${base}[parent_id]`, item.parent_id);
                  }

                  if (item.properties) {
                    Object.entries(item.properties).forEach(([key, value]) => {
                      newFormData.append(`${base}[properties][${key}]`, value);
                    })
                  }
                })
              }
            }

            let resProductId;

            await Alpine.store('xCartHelper').withCartLock((standardEvent) => fetch(`${Eurus.cart_add_url}`, {
              method:'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            }).then(reponse => {
              return Alpine.store('xCartHelper').cartJson(reponse);
            }).then(async (response) => {
              if (response.status == '422') {
                document.dispatchEvent(new CustomEvent("eurus:product:add-failed", {
                  detail: {
                    errorMessage: response.description
                  }
                }));
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
                await Alpine.store('xCartHelper').settleWithCart(standardEvent, Alpine.store('xCartHelper').userErrorsFrom(response));
              } else {
                resProductId = response.product_id;

                if (this.$refs.product_form) {
                  document.dispatchEvent(new CustomEvent(`eurus:cart:custom-options:reset:${this.$refs.product_form.getAttribute('id')}`));
                }

                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};
      
                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();
                document.dispatchEvent(new CustomEvent("eurus:video-popup:close-popup"));
                if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  Alpine.store('xCartHelper').reRenderSections(response.sections);
                  if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                    Alpine.store('xMiniCart').openCart();
                  }               
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
                  if (Alpine.store('xQuickView')) {
                    Alpine.store('xQuickView').openPopupMobile = false;
                  }
                  this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                  this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                  document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                  document.dispatchEvent(new CustomEvent("eurus:product:added", {
                    detail: {
                      product: response
                    }
                  }));
                }
                await Alpine.store('xCartHelper').settleWithCart(standardEvent);
              }
            }).catch((error) => {
              standardEvent.fail(error);
              document.dispatchEvent(new CustomEvent("eurus:product:add-failed", {
                detail: {
                  errorMessage: error
                }
              }));
              console.error('Error:', error);
            }).finally(() => {
              document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${resProductId}`));
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;
            }), {
              type: 'shopify:cart:lines-update',
              action: 'add',
              context: quickView ? 'dialog' : 'product',
              lines: Alpine.store('xCartHelper').addLines(newFormData)
            });
          }, 0)
        }
      }))
    });
  });

  // FRYE: Add to cart buttons wrapped in [data-atc-guard] explain why they are disabled.
  // A disabled button gets no click events, so the click lands on the wrapper (the button has
  // pointer-events: none while disabled, see snippets/frye-buttons.liquid). If an option such as
  // Size has not been picked, show "Please select a size" and move focus to that option.
  const fryeAtcGuardRoot = (guard) => {
    const selector = guard.dataset.optionsRoot;
    return (selector && document.querySelector(selector)) || guard.closest('form') || guard;
  };

  // A select counts as "not picked" when its selected option is a placeholder: value="" or, like
  // the theme's "Choose options" option, no value attribute at all.
  const fryeSelectIsEmpty = (select) => {
    const option = select.options[select.selectedIndex];
    return !option || !option.hasAttribute('value') || option.value === '';
  };

  const fryeFindMissingOption = (root) => {
    for (const group of root.querySelectorAll('[data-option-title]')) {
      const radios = group.querySelectorAll('input[type="radio"]');
      const select = group.matches('select') ? group : group.querySelector('select');
      // Options with a single value (e.g. one Colour) have nothing to choose, so never ask for them.
      if (radios.length > 1 && !group.querySelector('input[type="radio"]:checked')) {
        return { el: group, focus: radios[0] };
      }
      if (!radios.length && select) {
        const realOptions = Array.from(select.options).filter((option) => option.hasAttribute('value') && option.value !== '');
        if (realOptions.length > 1 && fryeSelectIsEmpty(select)) {
          return { el: group, focus: select };
        }
      }
    }
    return null;
  };

  const fryeClearAtcGuard = (guard) => {
    const messageEl = guard.querySelector('[data-atc-guard-message]');
    if (messageEl) {
      messageEl.hidden = true;
      messageEl.textContent = '';
    }
  };

  document.addEventListener('click', (event) => {
    const guard = event.target.closest('[data-atc-guard]');
    if (!guard) return;
    const button = guard.querySelector('button[name="add"]');
    if (!button || !button.disabled) return;
    const root = fryeAtcGuardRoot(guard);
    const missing = fryeFindMissingOption(root);
    if (!missing) return;
    event.preventDefault();
    fryeClearAtcGuard(guard);
    const messageEl = guard.querySelector('[data-atc-guard-message]');
    if (messageEl) {
      messageEl.textContent = guard.dataset.message || '';
      messageEl.hidden = false;
    }
    missing.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (missing.focus) missing.focus.focus({ preventScroll: true });
  });

  document.addEventListener('change', (event) => {
    document.querySelectorAll('[data-atc-guard]').forEach((guard) => {
      if (fryeAtcGuardRoot(guard).contains(event.target)) fryeClearAtcGuard(guard);
    });
  });

  // FRYE: Shop the Look picker (snippets/shop-the-look-buy.liquid).
  // Colour tiles + size buttons are radios. Colour may be a Combined Listing, so each colour carries
  // its own product's variants (data-stl-colours). Resolves the variant, sets the hidden id,
  // greys out sizes not available in the chosen colour, and swaps the card when the colour changes.
  const fryeStlSamePath = (a, b) => {
    try {
      return new URL(a, window.location.origin).pathname === new URL(b, window.location.origin).pathname;
    } catch (e) {
      return false;
    }
  };

  const fryeStlSwapCard = (form, colour, colourIndex) => {
    const card = form.closest('[data-stl-card]');
    if (!card) return;
    const previousUrl = card.dataset.stlUrl;
    const previousTitle = card.dataset.stlTitle;
    card.querySelectorAll('.x-card-title').forEach((el) => {
      el.textContent = colour.title;
    });
    card.querySelectorAll('a[href]').forEach((link) => {
      if (link.closest('.stl-buy') || !previousUrl || !fryeStlSamePath(link.getAttribute('href'), previousUrl)) return;
      link.setAttribute('href', colour.url);
      if (link.getAttribute('aria-label') === previousTitle) link.setAttribute('aria-label', colour.title);
    });
    const image = Array.from(card.querySelectorAll('img')).find((img) => !img.closest('.stl-buy'));
    if (image && colour.image) {
      image.setAttribute('srcset', colour.image.srcset);
      image.setAttribute('src', colour.image.src);
      image.setAttribute('alt', colour.image.alt);
    }
    const priceTemplate = form.querySelector(`template[data-stl-price-for="${colourIndex}"]`);
    const priceTarget = card.querySelector('[data-stl-price]') || card.querySelector('.x-card-price');
    if (priceTemplate && priceTarget) priceTarget.innerHTML = priceTemplate.innerHTML;
    card.dataset.stlUrl = colour.url;
    card.dataset.stlTitle = colour.title;
  };

  const fryeStlUpdate = (form, colourChanged) => {
    const coloursEl = form.querySelector('script[data-stl-colours]');
    if (!coloursEl) return;
    const colours = JSON.parse(coloursEl.textContent);
    const inputs = Array.from(form.querySelectorAll('input[type="radio"][data-option-index]'));
    const optionCount = inputs.reduce((max, input) => Math.max(max, Number(input.dataset.optionIndex) + 1), 0);
    const chosen = Array.from({ length: optionCount }, (_, index) => {
      const checked = inputs.find((input) => Number(input.dataset.optionIndex) === index && input.checked);
      return checked ? checked.value : null;
    });

    const colourInput = inputs.find((input) => input.dataset.colourIndex !== undefined && input.checked);
    const colourIndex = colourInput ? Number(colourInput.dataset.colourIndex) : 0;
    const colourOption = colourInput ? Number(colourInput.dataset.optionIndex) : -1;
    const colour = colours[colourIndex] || colours[0];
    // A colour product from a Combined Listing may not list the colour among its own options.
    const colourInVariants = colourInput && colour.variants.some((v) => v.options.includes(colourInput.value));
    const needed = (values) => values.filter((value, i) => value && (i !== colourOption || colourInVariants));
    const matches = (variant, values) => values.every((value) => variant.options.includes(value));

    inputs.forEach((input) => {
      if (input.dataset.colourIndex !== undefined) return;
      const index = Number(input.dataset.optionIndex);
      const candidate = chosen.slice();
      candidate[index] = input.value;
      const available = colour.variants.some((v) => v.available && matches(v, needed(candidate)));
      input.closest('.stl-button')?.classList.toggle('is-unavailable', !available);
    });

    const complete = chosen.every((value, i) => i === colourOption || value);
    const variant = complete ? colour.variants.find((v) => matches(v, needed(chosen))) : null;
    form.querySelector('[data-stl-variant-id]').value = variant ? variant.id : '';
    const button = form.querySelector('button[name="add"]');
    button.disabled = !variant || !variant.available;
    const label = form.querySelector('[data-stl-atc-label]');
    if (label) label.textContent = variant && !variant.available ? button.dataset.labelSoldOut : button.dataset.labelAdd;

    if (colourChanged) fryeStlSwapCard(form, colour, colourIndex);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('input[type="radio"][data-option-index]');
    const form = input && input.closest('form');
    if (!form || !form.querySelector('script[data-stl-colours]')) return;
    fryeStlUpdate(form, input.dataset.colourIndex !== undefined);
  });

  const fryeStlInit = () => {
    document.querySelectorAll('form script[data-stl-colours]').forEach((el) => {
      const form = el.closest('form');
      const card = form.closest('[data-stl-card]');
      const colours = JSON.parse(el.textContent);
      const colourInput = form.querySelector('input[data-colour-index]:checked');
      const colour = colours[colourInput ? Number(colourInput.dataset.colourIndex) : 0];
      if (card && colour && !card.dataset.stlUrl) {
        card.dataset.stlUrl = colour.url;
        card.dataset.stlTitle = colour.title;
      }
      fryeStlUpdate(form, false);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fryeStlInit);
  } else {
    fryeStlInit();
  }
}
